module.exports = __webpack_public_path__ + "static/media/confirmAlert.ef24cdf0.svg";